// `/leads/*` sub-tree layout — passes the outlet through unmodified.
// Mirrors the businesses layout pattern; the AppShell's main column
// supplies the page padding.

import { Outlet, createRoute } from '@tanstack/react-router';

import { Route as AuthedLayoutRoute } from '../__layout';

export const Route = createRoute({
  getParentRoute: () => AuthedLayoutRoute,
  path: 'leads',
  component: LeadsLayout,
});

function LeadsLayout() {
  return <Outlet />;
}
